/**
 * @file: heatmap.js iframe热力图页面脚本文件
 * @author: liuye11(liuye11@baidu.com)
 */

export const HEAT_MAP_SCRIPT = `
var RT_CONFIG = window['m' + window.HEAT_MAP_MCID + '_RT_CONFIG'];
var LINKS = window['m' + window.HEAT_MAP_MCID + '_LINKS'];

// 先处理LINK_IDS
for (var i = 0, len = LINKS.length; i < len; i++) {
    LINKS[i] = LINKS[i] + (LINKS[i].indexOf('?') > 0 ? '&' : '?') + '__linkId=' + RT_CONFIG.LINK_IDS[i];
    LINKS[i] = normalizeURL(LINKS[i]);
}

function normalizeURL(href) {
    var anchor = document.createElement('A');
    anchor.href = href;
    return anchor.href;
}

require.config({
    packages: [
        {
            name: 'componentHeatMapRender',
            location: 'https://ecmc.bdimg.com/public01/muses-plt/js',
            main: '<<ENVIRONMENT>>' === 'ONLINE' ? 'heatmap' : 'heatmap-rd'
        }
    ],
    urlArgs: {
        componentHeatMapRender: 't=' + Math.floor(Date.now() / 1000 / 60)
    }
});

(function (global) {
    var material;
    var clickRates = HEAT_MAP_DATA.click;
    var actionRates = HEAT_MAP_DATA.action;
    var $bodyMask;
    var beforeHeight;

    function initStyles () {
        var css = '\
            body {\
                position: relative;\
            }\
            .c-container {\
                margin: 0;\
            }\
            a {\
                pointer-events: none;\
            }\
            a.heat-map {\
                display: block;\
            }\
            .heat-map .heat-map-rate {\
                position: absolute;\
                z-index: 1000;\
                left: 0;\
                right: 0;\
                top: 0;\
                bottom: 0;\
                background-color: rgba(255, 0, 0, 0.3);\
                color: white;\
                text-align: center;\
                font-size: 16px;\
                display: flex;\
                justify-content: center;\
                flex-direction: column;\
            }\
            .canvas-mark {\
                position: absolute;\
                top: 0;\
                left: 0;\
                width: 100%;\
                height: 100%;\
                z-index: 1000;\
                background-color: rgba(0, 0, 0, .7);\
            }\
            .ctr-dot {\
                position: absolute;\
            }\
            .ctr-dot:hover {\
                background-color: rgba(255, 91, 91, .3);\
            }\
            .ctr-rate {\
                position: absolute;\
                left: 50%;\
                top: 50%;\
                transform: translate(-50%, -50%);\
                color: white;\
                width: 35px;\
                height: 35px;\
                border-radius: 50%;\
                line-height: 35px;\
                text-align: center;\
                background-color: rgba(255, 162, 162, .7);\
            }';

        $('head').append('<style>' + css + '</style>');
    }

    function initEvents () {
        // 添加message时间，用于控制是否显示热力图
        window.addEventListener('message', function (event) {
            var eventData = JSON.parse(event.data);
            switch (eventData.action) {
                case 'showmask':
                    generateHeatMap();
                    break;
                case 'hidemask':
                    $bodyMask.remove();
                    break;
            }
        }, false);

        // Firefox和Chrome早期版本中带有前缀
        var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

        var observer = new MutationObserver(function () {
            patchHeatMapTags(document.body);
            emitHeigt();
        });

        observer.observe(document.body, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['class', 'style']
        });
    }

    function postMessage(data) {
        if (window.parent) {
            window.parent.postMessage(JSON.stringify(data), '*');
        }
    }
    function emitHeigt() {
        var currentHeight = document.body.clientHeight;
        if (beforeHeight !== currentHeight) {
            beforeHeight= currentHeight;
            postMessage({
                action: 'height',
                value: beforeHeight + 1
            });
        }
    }

    function checkPacks(cb, beginTime) {
        if ((Date.now() - beginTime) > 5 * 1000) {
            postMessage({
                action: 'error',
                value: '当前物料不支持热力图'
            });
        }
        if (window.__pack) {
            cb();
        }
        else {
            setTimeout(function() {
                checkPacks(cb, beginTime)
            }, 100);
        }
    }

    function patchHeatMapTags(root) {
        if (!LINKS) {
            return;
        }
        $(root).find('a:not(.heat-map)').each(function (index, anchor) {
            var $anchor = $(anchor);
            var href = $anchor.prop('href')
            var index = LINKS.indexOf(href);
            if (index >= 0) {
                // 说明该链接是links id的。
                var linkId = RT_CONFIG.LINK_IDS[index];
                var clickRate = (clickRates[linkId] || -1) < 0 ? 0 : clickRates[linkId];
                $anchor.addClass('heat-map');
                $anchor.attr('data-ctr', clickRate);
            }
        });

        // 开始检测action
        material.eachChild(function (child) {
            var childActions = actionRates[child.musesPltId || 'notExited'] || [];
            if (window.componentHeatMapRender) {
                window.componentHeatMapRender(child, childActions);
            }
        });
    }

    function generateHeatMap() {
        $bodyMask = $('<div class="canvas-mark"></div>');
        $body = $(document.body);
        var heatMaps = Array.from($body.find('.heat-map'));
        var html = heatMaps.filter(function (ele) {
            return $(ele).height() && $(ele).width();
        }).map(function (ele) {
            var $ele = $(ele);
            var ctr = $ele.data('ctr');
            ctr = ((+ctr) * 100).toFixed(1);
            return {
                x: $ele.offset().left,
                y: $ele.offset().top,
                h: $ele.height(),
                w: $ele.width(),
                ctr: ctr
            }
        }).map(function (rect) {
            return '<div class="ctr-dot" style="width: '
                        + rect.w + 'px;height: '
                        + rect.h + 'px;top: '
                        + rect.y + 'px;left: '
                        + rect.x + 'px;">'
                        + '<div class="ctr-rate" style="background-color: '
                            + getColor(rect.ctr) + ';">'
                            + rect.ctr
                        + '</div>'
                + '</div>';
        }).join('');
        $bodyMask.append(html);
        $body.append($bodyMask);
    }

    function getColor(rate) {
        var colorSteps = [
            {
                max: 7,
                color: 'rgba(255, 162, 162, .7)' // '#ffa2a2'
            },
            {
                max: 20,
                color: 'rgba(255, 91, 91, .7)' // '#ff5b5b'
            },
            {
                max: 1000000,
                color: 'rgba(230, 0, 0, .7)' // '#e60000'
            }
        ];
        for (var i = 0, len = colorSteps.length; i < len; i++) {
            if (rate <= colorSteps[i].max) {
                return colorSteps[i].color;
            }
        }
    }

    initStyles();

    checkPacks(function () {
        material = new __pack.Material({
            data: __pack.data
        });
        material.render();
        require(['componentHeatMapRender'], function (render) {
            window.componentHeatMapRender = render;
            patchHeatMapTags(document.body);
            if (location.search.indexOf('hidemask=1') < 0) {
                generateHeatMap();
            }
            postMessage({
                action: 'ready'
            });
            emitHeigt();
            initEvents();
        });
    }, Date.now());

})(this);`;

